export enum ContractStatus {
    EmElaboracao = 1,
    AssinaturaOmnik = 2,
    AssinaturaConsultor= 3,
    Concluido = 4,
    Verificar = 5
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractStatus.ts